import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import logo from "../../images/logo-full.png"; // your logo path

const ResetPassword = () => {
 const { token } = useParams();
 const navigate = useNavigate();

 const [password, setPassword] = useState("");
 const [confirm, setConfirm] = useState("");
 const [loading, setLoading] = useState(false);

 const handleResetPassword = async (e) => {
 e.preventDefault();

 if (!password || !confirm) {
 return swal("Error", "All fields are required", "error");
 }

 if (password !== confirm) {
 return swal("Error", "Passwords do not match!", "error");
 }

 setLoading(true);

 try {
 const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/reset-password`, {
 token,
 password,
 });

 if (res.data.success) {
 swal("Success!", "Password reset successfully", "success");
 navigate("/");
 }
 } catch (error) {
 swal(
 "Error",
 error.response?.data?.message || "Reset link expired or invalid",
 "error"
 );
 } finally {
 setLoading(false);
 }
 };

 return (
 <div className="authincation h-100 d-flex align-items-center justify-content-center">
 <div className="container">
 <div className="row justify-content-center align-items-center h-100">
 <div className="col-md-6 col-lg-5">
 <div className="authincation-content shadow rounded p-4">
 <div className="text-center mb-3">
 <Link to="/">
 <img src={logo} alt="Logo" width={200} />
 </Link>
 </div>
 <h4 className="text-center mb-4 text-dark fw-bold">Reset Password</h4>

 <form onSubmit={handleResetPassword}>
 <div className="form-group mb-3">
 <label className="fw-semibold">New Password</label>
 <input
 type="password"
 className="form-control"
 placeholder="Enter new password"
 value={password}
 onChange={(e) => setPassword(e.target.value)}
 required
 />
 </div>

 <div className="form-group mb-3">
 <label className="fw-semibold">Confirm Password</label>
 <input
 type="password"
 className="form-control"
 placeholder="Confirm new password"
 value={confirm}
 onChange={(e) => setConfirm(e.target.value)}
 required
 />
 </div>

 <button
 type="submit"
 className="btn btn-primary w-100"
 disabled={loading}
 >
 {loading ? "Updating..." : "Reset Password"}
 </button>
 </form>

 <div className="text-center mt-3">
 <Link to="/" className="text-primary">
 ← Back to Login
 </Link>
 </div>

 </div>
 </div>
 </div>
 </div>
 </div>
 );
};

export default ResetPassword;
